import { useEffect, useState } from 'react'

// Hook to track whether the viewport matches mobile breakpoint (<640px).
// Uses matchMedia so it responds to resizes and respects best practices.
export default function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = useState<boolean>(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return false
        return window.matchMedia('(max-width: 639px)').matches
    })

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return

        const mq = window.matchMedia('(max-width: 639px)')
        const handle = (ev: MediaQueryListEvent) => setIsMobile(ev.matches)

        // Some browsers still use addListener
        if (mq.addEventListener) mq.addEventListener('change', handle)
        else mq.addListener(handle)

        // ensure state is correct
        setIsMobile(mq.matches)

        return () => {
            if (mq.removeEventListener) mq.removeEventListener('change', handle)
            else mq.removeListener(handle)
        }
    }, [])

    return isMobile
}
